import './style.scss'
import * as allIcons from './icons'
export const manifest = allIcons
export * from './icons'
export * from './components'
